import { FC } from 'react';
import { HorizontalPadder, MenuPage } from './common';
import { Stack } from '../globals';
import Skeleton from '../widgets/skeleton';
import { GalleryLoader } from '../widgets/gallery';

const DefaultContent = () => (
	<Stack $gap={8}>
		<Skeleton variant='rectangular' width='100%' height='48px' />
		<Skeleton variant='rectangular' width='100%' height='48px' />
		<Skeleton variant='rectangular' width='100%' height='48px' />
		<Skeleton variant='rectangular' width='100%' height='48px' />
		<Skeleton variant='rectangular' width='100%' height='48px' />
	</Stack>
);

type UploadContentProps = {
	compactMode?: boolean;
}
const UploadContent: FC<UploadContentProps> = ({ compactMode }) => {
	return (
		<Stack $gap={8}>
			<Skeleton variant='rectangular' width='100%' height='40px' />
			<Skeleton variant='rectangular' width='100%' height='40px' />
			<Skeleton variant='text' width='30%' fontSize='1em' />
			<GalleryLoader compactMode={compactMode} />
		</Stack>
	);
};

type GalleryContentProps = {
	compactMode?: boolean;
}
const GalleryContent: FC<GalleryContentProps> = ({ compactMode }) => {
	return (
		<Stack $gap={8}>
			<Stack $gap={8} $horizontal>
				<Skeleton variant='rectangular' width='50%' height='40px' />
				<Skeleton variant='rectangular' width='50%' height='40px' />
			</Stack>
			<GalleryLoader compactMode={compactMode} />
		</Stack>
	);
};

const TabbedContent = () => {
	return (
		<Stack $gap={8}>
			<Stack $gap={8} $horizontal>
				<Skeleton variant='text' width='30%' fontSize='1em' />
				<Skeleton variant='text' width='30%' fontSize='1em' />
				<Skeleton variant='text' width='30%' fontSize='1em' />
			</Stack>
			<Skeleton variant='rectangular' width='100%' height='60px' />
			<Skeleton variant='rectangular' width='100%' height='60px' />
			<Skeleton variant='rectangular' width='100%' height='60px' />
		</Stack>
	);
};

export type MenuSkeletonVariant = 'default' | 'upload' | 'gallery' | 'tabbed';
export type MenuSkeletonProps = {
	variant?: MenuSkeletonVariant;
	compactMode?: boolean;
};
const MenuSkeleton: FC<MenuSkeletonProps> = ({ variant = 'default', compactMode }) => (
	<MenuPage title={<Skeleton variant='text' width='70%' fontSize='1.2em' />} hideCloseButton>
		<HorizontalPadder>
			{variant === 'default' && <DefaultContent />}
			{variant === 'upload' && <UploadContent compactMode={compactMode} />}
			{variant === 'gallery' && <GalleryContent compactMode={compactMode} />}
			{variant === 'tabbed' && <TabbedContent />}
		</HorizontalPadder>
	</MenuPage>
);

export default MenuSkeleton;
